import React, { Component } from 'react';
import { BootstrapField, BootstrapError } from "../../../helpers/Field";
import * as yup from 'yup';
import { Formik } from "formik";
import { getConfiguration, smtpTest, updateConfiguration } from "../../../requests/ConfigRequests";
import CustomizingPage from "../customizing/CustomizingPage";
import { toast } from 'react-toastify';
import classNames from "classnames";
import { connect } from "react-redux";

const schema = yup.object().shape({
    companyName: yup.string().required(),
    applicationUrl: yup.string().required(),
    smtpAddress: yup.string().required(),
    smtpPort: yup.number().required(),
    smtpUseUser: yup.boolean(),
    registrationRequestEmail: yup.string().email(),
    registrationRequestEmailContent: yup.string(),
    registrationRequestorEmailContent: yup.string(),
    welcomeEmailContent: yup.string(),
    resetPasswordEmailContent: yup.string(),
    emailConfirmationContent: yup.string(),
    fromAddress: yup.string().email(),
    fromAddressName: yup.string(),
    receiptEmailBody: yup.string(),
    receiptEmailRow: yup.string(),
    receiptBcc: yup.string(),
    smtpUser: yup.string().when('smtpUseUser', {
        is: true,
        then: yup.string().required(),
    }),
    smtpPassword: yup.string().when('smtpUseUser', {
        is: true,
        then: yup.string().required(),
    }),
    ccvideoUrl: yup.string().required(),
    ccpdfUrl: yup.string().required(),
    ecvideoUrl: yup.string().required(),
    ecpdfUrl: yup.string().required(),
});

class EditConfiguration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            config: null,
            showConfiguration: false,
            testEmail: "",
        };
        this.showConfiguration = this.showConfiguration.bind(this);
        this.sendTestEmail = this.sendTestEmail.bind(this);
    }

    componentDidMount() {
        getConfiguration().then(config => this.setState({ config: config }));
    }

    showConfiguration() {
        if (this.state.showConfiguration) {
            this.setState({ showConfiguration: false });
        } else {
            this.setState({ showConfiguration: true });
        }
    }

    sendTestEmail(values) {
        let testEmail = prompt("Test Email", this.state.testEmail);
        this.setState({
            ...this.state,
            testEmail: testEmail,
        });
        smtpTest({ ...values, testEmail: testEmail }).then((message) => {
            alert(message);
        });
    }

    render() {
        let sapStatusGood = this.props.sapConfig.statusCode === 200 && this.props.sapConfig.data.status.message_type === "S";


        return (
            <div className="container">
                {this.state.config && <Formik
                    validationSchema={schema}
                    onSubmit={(values, bag) => {
                        bag.setSubmitting(true);
                        console.log("values...", values);
                        updateConfiguration(values).then(() => {
                            toast.success("Configuration Saved", { position: toast.POSITION.TOP_RIGHT });
                            bag.setSubmitting(false);
                        })
                    }}
                    initialValues={this.state.config}
                    render={props => <form onSubmit={props.handleSubmit}>
                        <div className="row">
                            <div className="col-12 card">
                                <div className={"row"}>
                                    <div className="col-lg-9 col-md-12">
                                        <h4>SAP Connection Status: {sapStatusGood ? "Good" : "Error"}</h4>
                                        {!sapStatusGood && <div>
                                            {this.props.sapConfig.statusMessage}<br />
                                            {this.props.sapConfig.statusCode === 200 &&
                                                <React.Fragment>{this.props.sapConfig.data.status.message_type}<br />
                                                    {this.props.sapConfig.data.status.message_line_string}<br />
                                                </React.Fragment>}
                                        </div>}
                                    </div>
                                </div>
                                <div className={"row mt-4"}>
                                    <div className="col-lg-9 col-md-12">
                                        <h3>Configuration</h3>
                                        <div>
                                            <div className={"form-group row"}>
                                                <label className="col-4 col-form-label-sm text-secondary bold">Application Url</label>
                                                <div className="col">
                                                    <BootstrapField name="applicationUrl" placeholder="Application Url" />
                                                    <BootstrapError name="applicationUrl" />
                                                </div>
                                            </div>
                                            <div className={"form-group row"}>
                                                <label className="col-4 col-form-label-sm text-secondary bold">Company Name</label>
                                                <div className="col">
                                                    <BootstrapField name="companyName" placeholder="Company Name" />
                                                    <BootstrapError name="companyName" />
                                                </div>
                                            </div>
                                            <h5>Email Configuration</h5>
                                            <div className={"form-group row"}>
                                                <label className="col-4 col-form-label-sm text-secondary bold">SMTP Address</label>
                                                <div className="col">
                                                    <BootstrapField name="smtpAddress" placeholder="Smtp Domain/IP Address" />
                                                    <BootstrapError name="smtpAddress" />
                                                </div>
                                            </div>
                                            <div className={"form-group row"}>
                                                <label className="col-4 col-form-label-sm text-secondary bold">SMTP Port</label>
                                                <div className="col">
                                                    <BootstrapField name="smtpPort" placeholder="Smtp Port" />
                                                    <BootstrapError name="smtpPort" />
                                                </div>
                                            </div>
                                            <div className={"form-group row"}>
                                                <label className="col-4 col-form-label-sm text-secondary bold">From Address</label>
                                                <div className="col">
                                                    <BootstrapField name="fromAddress" placeholder="From Address" />
                                                    <BootstrapError name="fromAddress" />
                                                </div>
                                            </div>
                                            <div className={"form-group row"}>
                                                <label className="col-4 col-form-label-sm text-secondary bold">From Address Name</label>
                                                <div className="col">
                                                    <BootstrapField name="fromAddressName" placeholder="From Address Name" />
                                                    <BootstrapError name="fromAddressName" />
                                                </div>
                                            </div>
                                            <div className={"form-group form-check"}>
                                                <BootstrapField id="smtpUseUser" name="smtpUseUser"
                                                    placeholder="Smtp Domain/IP Address"
                                                    type={"checkbox"} checked={props.values.smtpUseUser} />
                                                <label htmlFor="smtpUseUser" className="form-check-label">Use Authentication User</label>
                                            </div>
                                            {props.values.smtpUseUser && <React.Fragment>
                                                <div className={"form-group row"}>
                                                    <label className="col-4 col-form-label-sm text-secondary bold">SMTP User</label>
                                                    <div className="col">
                                                        <BootstrapField name="smtpUser" placeholder="SMTP User" />
                                                        <BootstrapError name="smtpUser" />
                                                    </div>
                                                </div>
                                                <div className={"form-group row"}>
                                                    <label className="col-4 col-form-label-sm text-secondary bold">SMTP Password</label>
                                                    <div className="col">
                                                        <BootstrapField name="smtpPassword" placeholder="SMTP Password" type="password" />
                                                        <BootstrapError name="smtpPassword" />
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                            }
                                            <button className={"btn"} onClick={(event) => {
                                                event.preventDefault();
                                                this.sendTestEmail(props.values);
                                            }}>Test Email
                                            </button>
                                            <h5>Registration Request Email</h5>
                                            <p>
                                                <small>This email address will be used to send notifications for new registration requests.
                                                </small>
                                            </p>
                                            <div className={"form-group row"}>
                                                <label className="col-4 col-form-label-sm text-secondary bold">Email Address</label>
                                                <div className="col">
                                                    <BootstrapField name="registrationRequestEmail" placeholder="Email Address" />
                                                    <BootstrapError name="registrationRequestEmail" />
                                                </div>
                                            </div>
                                            <h5>Email Content</h5>
                                            <p>
                                                <small>
                                                    This is the content of the email that will be sent when a new registration is requested.
                                                </small>
                                            </p>
                                            <div className={"form-group row"}>
                                                <label className="col-4 col-form-label-sm text-secondary bold">Registration Request Email
                                                    Content</label>
                                                <div className="col">
                                                    <BootstrapField component="textarea" rows="10" name="registrationRequestEmailContent"
                                                        placeholder="Email Content" />
                                                    <BootstrapError name="registrationRequestEmailContent" />
                                                </div>
                                            </div>
                                            <p>
                                                <small>
                                                    This is the content of the email that will be sent to the registration requestor when their
                                                    request is submitted
                                                </small>
                                            </p>
                                            <div className={"form-group row"}>
                                                <label className="col-4 col-form-label-sm text-secondary bold">Registration Requestor Email
                                                    Content</label>
                                                <div className="col">
                                                    <BootstrapField component="textarea" rows="10" name="registrationRequestorEmailContent"
                                                        placeholder="Email Content" />
                                                    <BootstrapError name="registrationRequestorEmailContent" />
                                                </div>
                                            </div>
                                            <p>
                                                <small>
                                                    This is the content of the email that will be sent to a new user when their registration is
                                                    confirmed.
                                                </small>
                                            </p>
                                            <div className={"form-group row"}>
                                                <label className="col-4 col-form-label-sm text-secondary bold">Welcome Email Content</label>
                                                <div className="col">
                                                    <BootstrapField component="textarea" rows="10" name="welcomeEmailContent"
                                                        placeholder="Email Content" />
                                                    <BootstrapError name="welcomeRequestEmailContent" />
                                                </div>
                                            </div>
                                            <p>
                                                <small>
                                                    This is the content of the email that will be sent when a password reset is requested.
                                                </small>
                                            </p>
                                            <div className={"form-group row"}>
                                                <label className="col-4 col-form-label-sm text-secondary bold">Reset Password Email
                                                    Content</label>
                                                <div className="col">
                                                    <BootstrapField component="textarea" rows="10" name="resetPasswordEmailContent"
                                                        placeholder="Email Content" />
                                                    <BootstrapError name="resetPasswordEmailContent" />
                                                </div>
                                            </div>
                                            <div className={"form-group row"}>
                                                <label className="col-4 col-form-label-sm text-secondary bold">Confirmation Email Content
                                                    Content</label>
                                                <div className="col">
                                                    <BootstrapField component="textarea" rows="10" name="emailConfirmationContent"
                                                        placeholder="Email Content" />
                                                    <BootstrapError name="emailConfirmationContent" />
                                                </div>
                                            </div>
                                            <div className={"form-group row"}>
                                                <label className="col-4 col-form-label-sm text-secondary bold">Receipt Email Body</label>
                                                <div className="col">
                                                    <BootstrapField rows="10" name="receiptBcc"
                                                        placeholder="Email" />
                                                    <BootstrapError name="receiptBcc" />
                                                </div>
                                            </div>
                                            <div className={"form-group row"}>
                                                <label className="col-4 col-form-label-sm text-secondary bold">Receipt Email Body</label>
                                                <div className="col">
                                                    <BootstrapField component="textarea" rows="10" name="receiptEmailBody"
                                                        placeholder="Email Content" />
                                                    <BootstrapError name="receiptEmailBody" />
                                                </div>
                                            </div>
                                            <div className={"form-group row"}>
                                                <label className="col-4 col-form-label-sm text-secondary bold">Receipt Email Row</label>
                                                <div className="col">
                                                    <BootstrapField component="textarea" rows="10" name="receiptEmailRow"
                                                        placeholder="Email Content" />
                                                    <BootstrapError name="receiptEmailRow" />
                                                </div>
                                            </div>

                                            <div className={"form-group row"}>
                                                <label className="col-4 col-form-label-sm text-secondary bold">Payment Instructions: CC PDF</label>
                                                <div className="col">
                                                    <BootstrapField name="ccpdfUrl" placeholder="Payment Instructions: CC PDF Url" />
                                                    <BootstrapError name="ccpdfUrl" />
                                                </div>
                                            </div>

                                            <div className={"form-group row"}>
                                                <label className="col-4 col-form-label-sm text-secondary bold">Payment Instructions: CC Video</label>
                                                <div className="col">
                                                    <BootstrapField name="ccvideoUrl" placeholder="Payment Instructions: CC Video Url" />
                                                    <BootstrapError name="ccvideoUrl" />
                                                </div>
                                            </div>

                                            <div className={"form-group row"}>
                                                <label className="col-4 col-form-label-sm text-secondary bold">Payment Instructions: EC PDF</label>
                                                <div className="col">
                                                    <BootstrapField name="ecpdfUrl" placeholder="Payment Instructions: EC PDF Url" />
                                                    <BootstrapError name="ecpdfUrl" />
                                                </div>
                                            </div>

                                            <div className={"form-group row"}>
                                                <label className="col-4 col-form-label-sm text-secondary bold">Payment Instructions: EC Video</label>
                                                <div className="col">
                                                    <BootstrapField name="ecvideoUrl" placeholder="Payment Instructions: EC Video Url" />
                                                    <BootstrapError name="ecvideoUrl" />
                                                </div>
                                            </div>
                                            <div className={"form-group row"}>
                                                <div className={classNames("image-upload-tab", { "active": this.state.showConfiguration })}
                                                    onClick={this.showConfiguration}>SAP Configuration
                                                </div>
                                            </div>
                                            <div className={"form-group row"}>
                                                {this.state.showConfiguration ?
                                                    <CustomizingPage /> : ''
                                                }
                                            </div>
                                            <br />
                                            <div>
                                                <button className={"btn btn-primary"} type={"submit"}>Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </form>} />}
            </div>

        );
    }
}

export default connect((state, props) => {
    return {
        sapConfig: state.app.config.sap,
    }
})(EditConfiguration);
